const MyConfig = {
  getBaseUrl: () => process.env.REACT_APP_API_URL,
  isPartner: (userAccId) => {
    if (parseInt(userAccId, 10) === 2) {
      return process.env.CX_ADMIN;
    }

    if (parseInt(userAccId, 10) === 3) {
      return process.env.CX_PART;
    }

    return null;
  },
  getCDNServer: () => process.env.CDN,
  getGoogleMapsKey: () =>
    process.env.GOOGLE_MAPS_KEY || 'AIzaSyBUjTI5qDBNvALVxQc8mrqHjnWCxoIrPPA',
  dateTimeFormat: {
    FULL: 'HH:mm DD/MM/YYYY',
  },
};
export default MyConfig;
